export const env = {
  AUTH_API_URL: process.env.REACT_APP_AUTH_API_URL || 'https://internal.podstack.ai/auth/',
  INFERENCE_API_URL: process.env.REACT_APP_INFERENCE_API_URL || 'https://cloud.podstack.ai/infer/',
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
  CUSTOMER_LOGIN_URL: process.env.REACT_APP_CUSTOMER_LOGIN_URL || 'https://cloud.podstack.ai/portal/login',
  // Absolute URL to the customer-portal wallet/top-up page (different subdomain,
  // so it MUST be absolute - a relative /wallet would stay on inference.podstack.ai).
  WALLET_TOPUP_URL: process.env.REACT_APP_WALLET_TOPUP_URL || 'https://cloud.podstack.ai/portal/wallet',
  // platform-service base URL - hosts the wallet APIs (/wallet, /wallet/topup,
  // /wallet/transactions, /wallet/paypal/*). Includes the /api/v1 segment.
  PLATFORM_API_URL: process.env.REACT_APP_PLATFORM_API_URL || 'https://cloud.podstack.ai/platform/api/v1',
  PAYPAL_CLIENT_ID: process.env.REACT_APP_PAYPAL_CLIENT_ID || '',
  ENABLE_PAYPAL: process.env.REACT_APP_ENABLE_PAYPAL === 'true',
};
